import React, { StatelessComponent } from 'react';

const Loader: StatelessComponent = () => (
  <p>Loading</p>
)

export default Loader;